import { getConfigDetails } from '../services/config'

export const APICONFIG = {
	getUserLoginUrl: `${getConfigDetails().baseURL}oauth/access_token`,
	singupUrl: `${getConfigDetails().baseURL}sign-up`,
	getPassListUrl: `${getConfigDetails().baseURL}get-mapco-passes`,
	getEventListUrl: `${getConfigDetails().baseURL}get-mapco-event-list`,
	downloadQrcodeRequestUrl: `${getConfigDetails().baseURL}mapco-download-qrcode`,
	downloadPassQrcodeRequestUrl: `${getConfigDetails().baseURL}download-passes`,
	// STORE EVENT LOG
	storeEventLog: `${getConfigDetails()?.baseURL}addUserEvent`,
	// UPDATED USER PROFILE
	updateUserProfileUrl: `${getConfigDetails().baseURL}diamond-update-profile`,
	// Get user profile
	getUserProfileUrl: `${getConfigDetails().baseURL}diamond-get-user-by-id`,
	// Get user profile
	getUserProfileData: `${getConfigDetails().baseURL}api`,
	// Reset Password
	postRestPassword: `${getConfigDetails().baseURL}reset-are-password`,
	// GET PARTNER DETAILS BY SLUG
	getPartnerBySlug: `${getConfigDetails().baseURL}partner-details-by-slug`,
	// for the api before payment 
	saveBookingBeforePaymentUrl: `${getConfigDetails().baseURL}mapco-booking-before-payment`,
	// GET SESSION DETAILS
	getSessionDetails: `${getConfigDetails().baseURL}planet-payment-session-pci`,
	// after payment api
	saveBookingafterPaymentUrl: `${getConfigDetails().baseURL}mapco-booking-after-payment`,
	// API TO UPDATE PROMOCODE USAGES
	getPromoCodeUsage: `${getConfigDetails().baseURL}update_promocode_usage`,

	// forgot password 
	sendEmailResetPassword: `${getConfigDetails().baseURL}user/reset-password/email`,

	// Passowrd Reset
	resetPassword: `${getConfigDetails()?.baseURL}user/reset-password`,

	// nonce payment gate way api 
	noncePaymentGateway: `${getConfigDetails().baseURL}event-booking-web`,

	// GET CARD LIST URL
	getCardDataUrl: `${getConfigDetails().baseURL}get-card-profile`,

	// filtered event list url 
	getFilteredEventDataByDate: `${getConfigDetails().baseURL}get-event-date-list`,
	getVehicleListUrl: `${getConfigDetails().baseURL}get-vehicle-list`,
	getVehicleModelUrl: `${getConfigDetails().baseURL}get-all-make-models`,

	getApplePassWalletDownload: `${getConfigDetails()?.baseURL}genarate-pass-apple-wallet-pass`,
	getGooglePassWalletDownload: `${getConfigDetails()?.baseURL}genarate-pass-google-wallet-pass`,

	getAppleReservationWalletDownload: `${getConfigDetails()?.baseURL}genarate-reservation-apple-wallet-pass`,
	getGoogleReservationWalletDownload: `${getConfigDetails()?.baseURL}genarate-reservation-google-wallet-pass`,

}
